$(document).ready(function(){
    
   let focusSwiper = new Swiper('.focus', {
        autoplay: true,
        slidesPerView : 1, 
        pagination: {
            el: '.swiper-pagination',
        }, 
    })

    $(".p3Content li:first").addClass("on");
        $(".p3Content li").on("mouseover", function() {
            var i = $(".p3Content li").index(this);
            $(".p3Content li").eq(i).addClass("on").siblings().removeClass("on");
        });

})